/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {MouseEventHandler} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {FloatingIconButtonGroup} from '@ion/dls/src/components/buttons/FloatingIconButton';
import Tooltip from '@ion/dls/src/components/tooltip/Tooltip';
import {GridRefreshIcon} from '@ion/dls/src/icons/GridRefreshIcon';
import {IconSize, MarkerProps} from '@ion/dls/src/types/types';

type RefreshToolProps = Omit<MarkerProps, 'color'>;

// defines the prop definition for RefreshToolFactory component...
export interface RefreshToolFactoryProps {
  onRefresh: MouseEventHandler<Element>;
};

/**
 * The RefreshTool provides the UI for refresh icon that can be placed on the
 * map layers.
 *
 * ```typescript
 *
 *   <RefreshTool size={} onClick={function() {}} />
 *
 * ```
 */
export const RefreshTool = ({size, onClick}: RefreshToolProps) => (
  <FloatingIconButtonGroup>
    <FloatingIconButtonGroup.FloatingIconButton onClick={onClick}>
      <GridRefreshIcon size={size} />
    </FloatingIconButtonGroup.FloatingIconButton>
  </FloatingIconButtonGroup>
);

/**
 * The RefreshToolFactory funtion is responsible for creating a Refresh Tool/widget
 * component that provide an option to refresh the map content. This is a stand-alone
 * tool, can be usable in any of position on the map.
 *
 * ```typescript
 *
 *  import RefreshToolFactory from '../tools/RefreshTool';
 *
 *  const component = RefreshToolFactory({onRefresh});
 *
 * ```
 */
export const RefreshToolFactory = ({
  onRefresh
}: RefreshToolFactoryProps) => (
  <Tooltip title={translate('maps:controls.refresh')}>
    <div>
      <RefreshTool size={IconSize.medium} onClick={onRefresh} />
    </div>
  </Tooltip>
);

export default RefreshToolFactory;
